import React from 'react';
import RefreshIcon from "../../assets/images/collaborations/pr/manage/icon_refresh.svg";


function MessageHeader({ handleClick, moduleItem, company }) {
    const targetInfo = moduleItem || company || null;
    const companyName = targetInfo && targetInfo.company_name;
    return (
        <div className="chat-context--container">
            <div>
                {companyName ? <p className='company-title'>Company: {companyName}</p> : null}
                <p className='title'>{moduleItem.title}</p>
            </div>
            <button className='btn cursor-pointer' onClick={handleClick}>
                Reset context <img src={RefreshIcon} />
            </button>
        </div>
    )
}

export default MessageHeader